import { render, staticRenderFns } from "./TermAndConditionComponent.vue?vue&type=template&id=3004d465"
import script from "./TermAndConditionComponent.vue?vue&type=script&lang=js"
export * from "./TermAndConditionComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports